import { SparklesIcon } from 'lucide-react';
import { observer } from 'mobx-react-lite';
import StockSearchInput, { StockSearchResult } from '../StockSearchInput';
import { WeightItem } from '../StrategyWeightInput';

interface StrategyStockActionsProps {
    weights: WeightItem[];
    onAIRecommend: () => void;
    onStockSelect: (stock: StockSearchResult) => void;
}

/**
 * 종목 추가 액션 섹션
 * - AI 추천 버튼
 * - 검색 입력창
 */
const StrategyStockActions = observer(
    ({ weights, onAIRecommend, onStockSelect }: StrategyStockActionsProps) => {
        return (
            <>
                {/* AI 추가 버튼 */}
                <button
                    className="btn btn-soft btn-block mt-5"
                    onClick={(e) => {
                        e.preventDefault();
                        onAIRecommend();
                    }}
                >
                    <SparklesIcon className="size-5" />
                    AI로 추가하기
                </button>

                {/* 직접 검색 입력창 */}
                <div className="mt-3">
                    <StockSearchInput
                        onSelect={onStockSelect}
                        excludeTickers={weights.map((w) => w.ticker)}
                        placeholder="검색해서 추가하기 (티커 또는 종목명)"
                        clearOnSelect={true}
                        dropdownDirection="up"
                    />
                </div>
            </>
        );
    },
);

export default StrategyStockActions;
